<template>


	<v-layout>
			<v-flex xs12 v-if="!isUploading && !isRemoving">
				<v-card v-if="f.uploaded === true" v-for="(f, i) in files" :key="i">
						
					<v-card-title>{{f.name}}</v-card-title>
					 <video v-if="f.uploaded === true" controls>
		 			 	<source :src="path + '/' + route.name + '/' +  parseFile(f.name)"
		 			 		
		 			 	>
		 			 </video>
					<v-radio-group v-model="i">
				      <v-radio
				        v-for="(s, c) in seasons"
				        :key="c"
				        :label="s.text"
				        :value="c"
				        :color="getColor(f)"
				        @change="setSeasonSelected(f, c)"
				      ></v-radio>


				    </v-radio-group>
				
				</v-card>

		</v-flex>
		<!--v-btn @click="store()">
			<v-icon>save</v-icon>
			Save
		</v-btn-->
		
	</v-layout>
		 	
	<!--/v-container-->
</template>

<script>

	import {parseFileName} from '../../../tools';
	
	export default {
		name: 'SeasonVideoAnswers',
		data()
		{
			return{}
		},

		updated()
		{
			
		},

		created(){
			/*window.vm.$on('seasonSet', () => {
				
				this.$forceUpdate();
			})*/
		},

		methods: {

			parseFile(f)
			{
				return parseFileName(f)
			},


			getColor(f)
			{
				//this.$forceUpdate();
				let c = "primary"
				if( typeof this.newTask !== 'undefined'
				&& typeof this.newTask.answers !== 'undefined'
				&& typeof this.newTask.answers[f.name]
				&& typeof this.newTask.answers[f.name].error !== 'undefined') 
				{
					c = "red"
				}

				
				//console.log(this.newTask.answers[f.name])


				return c;
			},

			setSeasonSelected(f, c)
			{
				this.$store.dispatch('checkpoints/setSeason', {f: f, c:c})



				//this.$forceUpdate()

				this.$store.dispatch('checkpointsValidator/validateSeasonVideoTask')
				.then((valid) => {
					//console.log("validateSeasonVideoTask", valid)
					this.$store.commit('checkpointsValidator/setValid', valid)
				})

			},

			
		},

		

		computed: {

			isRemoving: {
				get()
				{
					return this.$store.getters['files/isRemoving'];
				}
			},

			route: {
				get()
				{
					return this.$store.getters['routes/route']
				}
			},

			path: {
				get()
				{	
					let p = this.$store.getters['checkpoints/fullPath'];
					
					return p;
				}
			},

			isUploading:
			{
				get()
				{
					return this.$store.getters['files/isUploading'];
				}
			},


			seasons: {
				get()
				{
					return this.$store.getters['checkpoints/seasons']
				}
			},

			translater: {
				get()
				{
					return this.$store.getters['translate/translater'];
				}
			},

			files: {
				get()
				{
					return this.$store.getters['files/filesToUpload'];
				}
			},

			path: {
				get()
				{	
					let p = this.$store.getters['checkpoints/fullPath'];
					
					return p;
				}
			},

			route: {
				get()
				{
					return this.$store.getters['routes/route']
				}
			},

			newTask: {
				get()
				{
					return this.$store.getters['checkpoints/newTask']
				}
			},

			

		}
	}
</script>

